export default "__VITE_ASSET__2_ec$CTk__"